module.exports = __webpack_public_path__ + "img/Calendar.364aa414.svg";